var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getState, num, setState } from './helpers';
import { resolveBounds } from './layout';
import { installAutoWidgetRebuild } from './refresh';
import { automotiveFontScaleFromProps, runWithAutomotiveFontScale, } from './themes';
var registry = {};
export function registerAutomotive(type, factory) {
    registry[type] = factory;
}
function isAutoGroup(node) {
    var _a;
    return 'children' in node && typeof ((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.autoType) === 'string';
}
function runFactory(factory, props, app) {
    var scale = automotiveFontScaleFromProps(props);
    if (scale == null)
        return factory(props, app);
    return runWithAutomotiveFontScale(scale, function () { return factory(props, app); });
}
export function createAutomotiveFromJSON(type, props, app) {
    var factory = registry[type];
    if (!factory)
        return null;
    var node = runFactory(factory, props, app);
    if (node && isAutoGroup(node)) {
        var state = getState(node);
        var bounds = resolveBounds(__assign(__assign({}, state), props), num(props, 'width', 160), num(props, 'height', 120));
        if (!num(state, 'width', 0) || !num(state, 'height', 0)) {
            setState(node, { width: bounds.width, height: bounds.height });
            node.metadata.chartWidth = bounds.width;
            node.metadata.autoWidth = bounds.width;
            node.metadata.chartHeight = bounds.height;
            node.metadata.autoHeight = bounds.height;
        }
        // Preserve component fontSize across rebuilds
        if (props.fontSize != null)
            setState(node, { fontSize: props.fontSize });
        if (props.demoId != null) {
            setState(node, { demoId: props.demoId });
            node.metadata.demoId = props.demoId;
        }
        installAutoWidgetRebuild(node, app, type);
    }
    return node;
}
export { registry, runFactory };
